module.exports = __webpack_public_path__ + "static/img/High Tear Strength Silicone Rubber For Molding.1480c89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/High Tear Strength Silicone Rubber For Molding.jpg
// module id = etI3
// module chunks = 1